import React, { Component } from 'react';
import PropTypes from 'prop-types';

class PaymentType extends Component {
  constructor (props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.state = {
      payment: props.checkoutState.payment
    };
  }

  onChange (e) {
    const newState = this.state;
    newState.payment.paymentOption = e.currentTarget.value;
    this.setState(newState);
  }

  onSubmit (e) {
    e.preventDefault();
    const stepState = this.state;
    if (stepState.payment.paymentOption === 'instalments') {
      stepState.payment.paymentType = 'transfer';
    } else {
      stepState.payment.paymentType = 'stripe';
    }
    this.props.onSubmit(2, stepState);
  }

  render () {
    return (
      <form action='' className='checkout__form checkout__form--payment-type'>
        <h2>Payment type</h2>
        <ul className='form-fields simple-inputs'>
          <li>
            <label className='control radio'>
              <input id='oneOff' name='paymentType' type='radio' value='buyNow' checked={this.state.payment.paymentOption === 'buyNow'} onChange={this.onChange} />
              <span className='control-indicator' />
              One-off payment
              <p className='label-extra label-extra--always-show'>Pay in full via credit or debit card and start learning straight away.</p>
            </label>
          </li>
          <li>
            <label className='control radio'>
              <input id='instalments' name='paymentType' type='radio' value='instalments' checked={this.state.payment.paymentOption === 'instalments'} onChange={this.onChange} />
              <span className='control-indicator' />
              Pay in instalments (+5% fee)
              <p className='label-extra label-extra--always-show'>Can't afford to pay in one go? Not to worry! To ease the strain on your finances you can choose to split the cost monthly.</p>
            </label>
          </li>
          <li className='form-footer'>
            <button onClick={this.onSubmit} className='button button--l disabled' style={{marginLeft: '210px', marginRight: 'auto'}}>Next</button>
          </li>
        </ul>
      </form>
    );
  }
}

PaymentType.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  checkoutState: PropTypes.object.isRequired
};

export default PaymentType;



// WEBPACK FOOTER //
// ./src/views/Checkout/PaymentType/index.js